/**
 * Progress related events for Hogeschooltaal
 */
module.exports = {
  GOAL_LEVEL_CHANGE: 'EV-HST-GOAL-LEVEL-CHANGE',
  SUBJECT_PROGRESS_RESET: 'EV-HST-SBJ-PROGRESS-RESET',
  TOPIC_INIT_PROGRESS_SET: 'EV-HST-TPC-PROGRESS-INIT',
  TOPIC_PROGRESS_INCREASE: 'EV-HST-TPC-PROGRESS-INC',
  TOPIC_PROGRESS_DROP: 'EV-HST-TPC-PROGRESS-DROP',
  TOPIC_PROGRESS_RESET: 'EV-HST-TPC-PROGRESS-RESET',
  TOPIC_SET_AS_COMPLETED: 'EV-HST-TPC-COMPLETE',
  TOPIC_SET_AS_INCOMPLETED: 'EV-HST-TPC-INCOMPLETE',
  CORRECT_TEXT_QUESTION_SUCCESS: 'EV-HST-CTXQ-SUCCEED',
  CORRECT_TEXT_QUESTION_FAILURE: 'EV-HST-CTXQ-FAILED',
};
